<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M11.2497 4.45648L7.88397 12.0836L6.84546 11.6324L10.2112 4.00531L11.2497 4.45648Z"
      fill="#1373D9"
    />
    <path
      opacity="0.2"
      d="M13.5518 4.45648L10.1861 12.0836L9.14758 11.6324L12.5133 4.00531L13.5518 4.45648Z"
      fill="#1373D9"
    />
    <path
      opacity="0.2"
      d="M16.9137 10.9718L14.2884 16.6602L13.2577 16.1918L15.8827 10.5034L16.9137 10.9718Z"
      fill="#1373D9"
    />
    <path
      d="M19.9737 10.4883C20.3282 10.4883 20.6458 10.7067 20.7701 11.0363C20.8865 11.3453 20.8104 11.6913 20.58 11.9236L20.5318 11.9685L10.449 20.6751C9.43434 21.5511 7.93237 20.4362 8.49286 19.2229L11.3056 13.1345L12.0826 13.4872L12.8521 13.8365L10.9103 18.0395L17.7012 12.1758H15.278L16.056 10.4883H19.9737ZM15.224 3.14062C16.4066 3.14068 17.1986 4.33669 16.7454 5.40784L16.7228 5.45874L14.9446 9.30726L14.1714 8.95624L13.3983 8.60505L15.1433 4.82812H9.73102C9.2657 4.82816 8.8466 5.10739 8.67036 5.53474L6.62823 10.4883H10.8743L10.0964 12.1758H5.36166C5.07834 12.1758 4.81358 12.0356 4.65567 11.8022C4.49778 11.5688 4.4674 11.2727 4.57465 11.0125L7.09636 4.89587C7.53404 3.83428 8.57513 3.14066 9.73102 3.14062H15.224Z"
      fill="#1373D9"
    />
    <path
      d="M15.4206 8.27719L11.7875 16.1412L10.2416 15.4381L13.8749 7.57407L15.4206 8.27719Z"
      fill="#1373D9"
    />
  </svg>
</template>
